import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import paginateReports from './paginateReports'
import report from './report'
import delta from './delta'
import paginateComments from './paginateComments'
import user from './user'
import likes from './likes'
import saves from './saves'
import replies from './replies'
import paginateSearch from './paginateSearch'
import authReducer from './auth_reducer'
import apiReducer from './api_reducer'
import authUser from './auth_user'
import followers from './followers'
import following from './following'
import * as types from '../constants/ActionTypes'

const reportsByCategory = paginateReports({
	mapActionToKey: action => action.category,
	types: [
		types.REQUEST_REPORTS,
		types.RECEIVE_REPORTS
	]
})

const reportById = report({
	mapActionToKey: action => action.report_id,
	types: [
		types.REQUEST_REPORT,
		types.RECEIVE_REPORT,
		types.ADD_COMMENT,
		types.DELETE_COMMENT
	]
})

const deltaById = delta({
	mapActionToKey: action => action.report_id,
	types: [
		types.REQUEST_DELTA,
		types.RECEIVE_DELTA
	]
}) 

const commentsById = paginateComments({
	mapActionToKey: action => action.report_id,
	types: [
		types.REQUEST_COMMENTS,
		types.RECEIVE_COMMENTS,
		types.REFRESH_COMMENTS
	]
})

const likesById = likes({
	mapActionToKey: action => action.report_id,
	types: [
		types.REQUEST_LIKES,
		types.RECEIVE_LIKES
	]
})

const savesById = saves({
	mapActionToKey: action => action.report_id,
	types: [
		types.REQUEST_SAVES,
		types.RECEIVE_SAVES
	]
})

const userById = user({
	mapActionToKey: action => action.user_id,
	types: [
		types.REQUEST_USER,
		types.RECEIVE_USER,
		types.REQUEST_USER_REPORTS,
		types.RECEIVE_USER_REPORTS
	]
})

const repliesById = replies({
	mapActionToKey: action => action.comment_id,
	types: [
		types.REQUEST_REPLIES,
		types.RECEIVE_REPLIES
	]
}) 

const searchByFilter = paginateSearch({
	mapActionToKey: action => action.filter,
	types: [
		types.REQUEST_SEARCH,
		types.RECEIVE_SEARCH,
		types.REFRESH_SEARCH
	]
})

export default combineReducers({
	api: apiReducer,
	auth: authReducer,
	form: formReducer,
	user: authUser,
	followersById: followers,
	followingById: following,
	reportsByCategory,
	reportById,
	deltaById,
	commentsById,
	repliesById,
	likesById,
	savesById,
	userById,
	searchByFilter
})


// WEBPACK FOOTER //
// ./src/reducers/index.js